import {createRouter, createWebHistory, RouteLocation} from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import authService from "../services/authService";
import DirectoryView from "../views/DirectoryView.vue";
import ReportView from "@/views/ReportView.vue";
import KindergartenHeadsView from "@/views/KindergartenHeadsView.vue";
import KindergartenHeadView from "@/views/KindergartenHeadView.vue";
import ActAcceptanceView from "@/views/ActAcceptanceView.vue";
import ActReconciliationView from "@/views/ActReconciliationView.vue";
import EsfInvoiceReconciliationView from "@/views/EsfInvoiceReconciliationView.vue";
import DirectoryDetailView from "@/views/DirectoryDetailView.vue";
import AccessDenied from "@/views/AccessDenied.vue";
import ReportSignView from "@/views/ReportSignView.vue";
import ReportToSignView from "@/views/ReportToSignView.vue";
import Report1CView from "@/views/Report1CView.vue";
import ResetPasswordView from "@/views/ResetPasswordView.vue";
import TimesheetView from "@/views/TimesheetView.vue";
import ReportForMIOView from "@/views/ReportForMIOView.vue";
import FactPaymentView from "@/views/FactPaymentView.vue";
import PreCalculationTimesheetView from "@/views/PreCalculationTimesheetView.vue";
import KindergartenActReconciliationView from "@/views/KindergartenActReconciliationView.vue";
import KindergartenActReconciliationStatusView from "@/views/KindergartenActReconciliationStatusView.vue";
import ResetPasswordECPView from "@/views/ResetPasswordECPView.vue";
import KindergartenRetentionView from "@/views/KindergartenRetentionView.vue";
import KdgAdminNotifications from "@/views/KdgAdminNotifications.vue";
import KdgClientNotifications from "@/views/KdgClientNotifications.vue";
import TimesheetGeneralView from "@/views/TimesheetGeneralView.vue";
import ChildListView from "@/views/ChildListView.vue";
import ChildrenDetailView from "@/views/ChildrenDetailView.vue";
import KindergartenAnalyticsView from "@/views/KindergartenAnalyticsView.vue";
import ChildrenKindergartenView from "@/views/ChildrenKindergartenView.vue";
import ChildrenPaymentView from "@/views/ChildrenPaymentView.vue";
import ChildrenTimesheetView from "@/views/ChildrenTimesheetView.vue";
import KindergartenDirectoryView from "@/views/KindergartenDirectoryView.vue";
import KindergartenSpecialStandardView from "@/views/KindergartenSpecialStandardView.vue";
import Kindergarten1cActReconciliationView from "@/views/Kindergarten1cActReconciliationView.vue";
import AuditLogView from "@/views/AuditLogView.vue";
import LmsRequestLogView from "@/views/LmsRequestLogView.vue";
import ChildDuplicatesView from "@/views/ChildDuplicatesView.vue";

const adminRoles: string[] = authService.getAdminRoles();
const kindergartenHeadRoles: string[] = authService.getKindergartenHeadRoles();
const managerRoles: string[] = authService.getManagerRoles();
const managerSpkRoles: string[] = authService.getManagerSpkRoles();
const accountantRoles: string[] = authService.getAccountantRoles();
const findirRoles: string[] = authService.getFinDirRoles();

const routes = [
  {
    path: "/",
    component: HomeView,
    meta: { requiresAuth: false, roles: []},
    children: [
      {
        path: "/directory",
        name: "Directory",
        component: DirectoryView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...accountantRoles] },
        children: [
          {
            path: "kindergarten-directory",
            name: "KindergartenDirectory",
            component: KindergartenDirectoryView,
            meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...accountantRoles] }
          },
          {
            path: "kindergarten-special-standard",
            name: "KindergartenSpecialStandard",
            component: KindergartenSpecialStandardView,
            meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...accountantRoles] }
          }
        ],
      },
      {
        path: "/directory/:id",
        name: "DirectoryDetail",
        component: DirectoryDetailView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...accountantRoles] },
      },
      {
        path: "report",
        name: "Report",
        component: ReportView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] },
      },
      {
        path: "/kindergarten/heads",
        name: "KindergartenHeads",
        component: KindergartenHeadsView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
      },
      {
        path: "/kindergarten/head/:id",
        name: "KindergartenHead",
        component: KindergartenHeadView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] },
      },
      {
        path: "/acts/reconciliation",
        name: "ActReconciliation",
        component: ActReconciliationView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
      },
      {
        path: "/acts/acceptance",
        name: "ActAcceptance",
        component: ActAcceptanceView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...accountantRoles] },
      },
      {
        path: "/invoice/reconciliation",
        name: "EsfInvoiceReconciliation",
        component: EsfInvoiceReconciliationView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...accountantRoles, ...kindergartenHeadRoles] },
      },
      {
        path: "/report-sign",
        name: "ReportSign",
        component: ReportSignView,
        meta: { requiredAuth: true, roles: kindergartenHeadRoles }
      },
      {
        path: "/kindergarten/retention",
        name: "KindergartenRetention",
        component: KindergartenRetentionView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
      },
      {
        path: "/report/to/sign",
        name: "ReportToSign",
        component: ReportToSignView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
      },
      {
        path: "/report/1c",
        name: "Report1C",
        component: Report1CView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...accountantRoles] }
      },
      {
        path: "/timesheet",
        name: "Timesheet",
        component: TimesheetView,
        meta: { requiresAuth: true, roles: [...adminRoles, ...managerRoles] }
      },
      {
        path: "/timesheet/general",
        name: "TimesheetGeneral",
        component: TimesheetGeneralView,
        meta: { requiresAuth: true, roles: [...adminRoles, ...managerRoles] }
      },
      {
        path: "/timesheet/pre/calculation",
        name: "PreCalculationTimesheet",
        component: PreCalculationTimesheetView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
      },
      {
        path: "/report/forMIO",
        name: "ReportForMIO",
        component: ReportForMIOView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...accountantRoles] }
      },
      {
        path: "/kindergarten/analytics",
        name: "KindergartenAnalytics",
        component: KindergartenAnalyticsView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
      },
      {
        path: "/kindergarten/fact/payment",
        name: "FactPayment",
        component: FactPaymentView,
        meta: { requiresAuth: true, roles: [...accountantRoles, ...adminRoles] }
      },
      {
        path: "/kindergarten/act/reconciliation",
        name: "KindergartenActReconciliation",
        component: KindergartenActReconciliationView,
        meta: { requiresAuth: true, roles: [...kindergartenHeadRoles] }
      },
      {
        path: "/kindergarten/act/reconciliation/status",
        name: "KindergartenActReconciliationStatus",
        component: KindergartenActReconciliationStatusView,
        meta: { requiresAuth: true, roles: [...accountantRoles, ...adminRoles] }
      },
      {
        path: "/admin/notifications",
        name: "ANotifications",
        component: KdgAdminNotifications,
        meta: { requiresAuth: true, roles: [...managerSpkRoles, ...managerRoles, ...adminRoles] }
      },
      {
        path: "/children/duplicates",
        name: "ChildDuplicates",
        component: ChildDuplicatesView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
      },
      {
        path: "/admin/lms-log",
        name: "LmsRequestLog",
        component: LmsRequestLogView,
        meta: { requiresAuth: true, roles: [...adminRoles] }
      },
      {
        path: "/admin/audit",
        name: "AuditLog",
        component: AuditLogView,
        meta: { requiresAuth: true, roles: [...adminRoles] }
      },
      {
        path: "/client/notifications",
        name: "CNotifications",
        component: KdgClientNotifications,
        meta: { requiresAuth: true, roles: [...kindergartenHeadRoles] }
      },
      {
        path: "/children",
        name: "ChildrenInfo",
        component: ChildListView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
      },
      {
        path: "/kindergarten-1c-act-reconciliation",
        name: "Kindergarten1cActReconciliation",
        component: Kindergarten1cActReconciliationView,
        meta: { requiresAuth: true, roles: [...kindergartenHeadRoles, ...findirRoles, ...accountantRoles] }
      },
      {
        path: "/children/:id",
        name: "ChildrenDetailInfo",
        component: ChildrenDetailView,
        meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] },
        children: [
          {
            path: "kindergartens",
            name: "childrenKindergartens",
            component: ChildrenKindergartenView,
            meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
          },
          {
            path: "payments",
            name: "childrenPayments",
            component: ChildrenPaymentView,
            meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
          },
          {
            path: "timesheets",
            name: "childrenTimesheets",
            component: ChildrenTimesheetView,
            meta: { requiresAuth: true, roles: [...managerRoles, ...adminRoles] }
          }
        ],
      }
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
    meta: { requiresAuth: false, roles: []},
  },
  {
    path: "/reset",
    name: "ResetPassword",
    component: ResetPasswordView,
    meta: { requiresAuth: false, roles: []},
  },
  {
    path: "/reset/password/ecp",
    name: "ResetPasswordECP",
    component: ResetPasswordECPView,
    meta: { requiresAuth: false, roles: [] },
  },
  {
    path: "/access-denied",
    name: "AccessDenied",
    component: AccessDenied,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!authService.getAccessToken();
  if (
    to.matched.some((record) => record.meta.requiresAuth) && !isAuthenticated
  ) {
    next({ path: "/login" });
  } else if (to.path === "/login" && isAuthenticated) {
    next({ path: "/" });
  } else if (isAuthenticated) {
    const requiredRoles = to.meta.roles as string[] | undefined;
    if (requiredRoles && requiredRoles.length == 0) { next(); }
    const hasAccess = authService.checkRoleAccessFromToken(authService.getAccessToken() || '', requiredRoles || []);
    if (hasAccess) {
      next();
    } else {
      console.log('redirect');
      next({ path: "/" });
    }
  } else {
    next();
  }
});

export default router;
